import { render, staticRenderFns } from "./create-or-edit-interface-authorize.vue?vue&type=template&id=5aa8092a&scoped=true"
import script from "./create-or-edit-interface-authorize.vue?vue&type=script&lang=js"
export * from "./create-or-edit-interface-authorize.vue?vue&type=script&lang=js"
import style0 from "./create-or-edit-interface-authorize.vue?vue&type=style&index=0&id=5aa8092a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa8092a",
  null
  
)

export default component.exports